/** 仅 App 现场作业（网页后台不展示） */
export const APP_ONLY_MENU_KEYS = new Set(['express', 'pick', 'delivery', 'return', 'load'])

/** 可分配给配送员的菜单（不含账号管理等敏感项；送序/客户地图已并入客户管理，不再单独分配） */
export const DELIVERY_MENU_OPTIONS = [
  { key: 'portal', path: '/portal', label: '工作台' },
  { key: 'express', path: '/express', label: '取快递', badge: 'express' },
  { key: 'pick', path: '/pick', label: '分检打标', badge: 'pick', portalOnly: true },
  { key: 'delivery', path: '/delivery', label: '配送管理', badge: 'delivery' },
  { key: 'return', path: '/delivery', query: { view: 'returning' }, label: '退货流程', portalOnly: true },
  { key: 'orders', path: '/orders', label: '订单管理' },
  { key: 'users', path: '/users', label: '客户管理' },
  { key: 'points', path: '/points', label: '积分管理' },
  { key: 'withdrawals', path: '/withdrawals', label: '提现记录' },
  { key: 'regions', path: '/regions', label: '区域管理' },
  { key: 'dashboard', path: '/dashboard', label: '统计' }
]

export const DEFAULT_DELIVERY_MENUS = ['portal', 'express', 'pick', 'delivery', 'return', 'users']

export function parseDeliveryMenus(raw) {
  const allow = new Set(DELIVERY_MENU_OPTIONS.map((m) => m.key))
  let list = []
  if (Array.isArray(raw)) {
    list = raw.map((x) => String(x || '').trim()).filter(Boolean)
  } else {
    const s = String(raw || '').trim()
    if (s) {
      try {
        const j = JSON.parse(s)
        if (Array.isArray(j)) list = j.map((x) => String(x || '').trim()).filter(Boolean)
        else list = s.split(/[,，\s]+/).map((x) => x.trim()).filter(Boolean)
      } catch (_) {
        list = s.split(/[,，\s]+/).map((x) => x.trim()).filter(Boolean)
      }
    }
  }
  // 旧配置里的 rank / map 并入客户管理
  list = list.map((k) => (k === 'rank' || k === 'map' ? 'users' : k))
  list = list.filter((k) => allow.has(k))
  list = [...new Set(list)]
  if (!list.length) list = [...DEFAULT_DELIVERY_MENUS]
  // 产品约定：配送员始终可进客户管理（含送序、客户地图）
  if (!list.includes('users')) list.push('users')
  if (!list.some((k) => k !== 'return')) {
    list = ['delivery', ...list.filter((k) => k === 'return')]
  }
  return list
}

export function menusByKeys(keys) {
  const set = new Set(parseDeliveryMenus(keys))
  return DELIVERY_MENU_OPTIONS.filter((m) => set.has(m.key))
}

/** 网页端侧栏：隐藏 App 专用菜单 */
export function filterWebSidebarMenus(items, inApp = false) {
  if (inApp) return items
  return items.filter((m) => !APP_ONLY_MENU_KEYS.has(m.key))
}

export function pathAllowedForDelivery(path, keys, query = {}) {
  const set = new Set(parseDeliveryMenus(keys))
  const p = String(path || '')
  // 工作台始终可进（卡片入口页）
  if (p === '/portal' || p === '/') return true
  if (p === '/delivery') {
    if (query.view === 'returning' || query.view === 'return') {
      return set.has('return') || set.has('delivery')
    }
    return set.has('delivery') || set.has('return')
  }
  // 客户地图并入客户管理
  if (p === '/customer-map') {
    return set.has('users') || set.has('delivery')
  }
  // 标签排版与分检共用权限
  if (p === '/label-templates') return set.has('pick')
  // 装车（大件/小件）：分检或配送均可进
  if (p === '/load') {
    return set.has('pick') || set.has('delivery')
  }
  // 旧送序页已并入客户管理
  if (p === '/rank') return set.has('users')
  const hit = DELIVERY_MENU_OPTIONS.find((m) => m.path === p && m.key !== 'return')
  if (!hit) return false
  return set.has(hit.key)
}

/** 配送员首页：优先工作台，避免落在子页导致「从首页点菜单被拦回原页」 */
export function firstDeliveryHome(keys) {
  const set = new Set(parseDeliveryMenus(keys))
  if (set.has('portal')) return '/portal'
  const menus = menusByKeys(keys).filter((m) => !m.portalOnly)
  if (menus.length) return menus[0].path
  return '/delivery'
}
